export const DATA_PATH = '/gust_generated';

export const REV = Object.freeze({
  WEB: process.env.REACT_APP_WEB_REV,
  GEN: process.env.REACT_APP_GEN_REV,
  SRC: process.env.REACT_APP_SRC_REV,
});
